import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Slide,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import MDButton from "components/MDButton";
import MDTextButton from "components/MDTextButton";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="fade" ref={ref} {...props} />;
});

const NewConfirmationDialog = ({
  title = "Confirm Action",
  description = "Are you sure?",
  dialogOpen,
  onClose,
  onConfirm,
  confirmLabel = "Confirm",
  loading = false,
}) => {
  return (
    <Dialog
      open={dialogOpen}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1.5,
          background: "#fafafa",
          boxShadow: "0 8px 28px rgba(0,0,0,0.18), 0 2px 8px rgba(0,0,0,0.08)",
        },
      }}
    >
      {/* Icon */}
      <Box
        sx={{
          width: 70,
          height: 70,
          borderRadius: "16px",
          background: "rgba(255,193,7,0.12)",
          mx: "auto",
          mt: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "pop 0.25s ease-out",
        }}
      >
        <WarningAmberRoundedIcon sx={{ fontSize: 42, color: "#ff9800" }} />
      </Box>

      {/* Content */}
      <DialogContent sx={{ textAlign: "center", mt: 1 }}>
        <Typography variant="h6" fontWeight={700} sx={{ mb: 1, fontSize: 18 }}>
          {title}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ px: 1.5, fontSize: 14 }}
        >
          {description}
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 2,
          gap: 2,
        }}
      >
        <MDTextButton onClick={onClose} sx={{ fontWeight: 500 }}>
          Cancel
        </MDTextButton>

        <MDButton
          color="info"
          onClick={onConfirm}
          disabled={loading}
          sx={{ px: 3, fontWeight: 600 }}
        >
          {confirmLabel}
        </MDButton>
      </DialogActions>

      <style>
        {`
          @keyframes pop {
            0% { transform: scale(0.6); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
    </Dialog>
  );
};

export default NewConfirmationDialog;
